module.exports = __webpack_public_path__ + "static/media/play.38346372.png";